import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { FileInput, UploadedMedia } from './inputMedia';
import styles from '../../../register/style.module.scss';

const MediaSection = ({ removeImage, media, handleImage, handleClick, loader }) => {
  return (
    <div>
      <Row>
        <Col>
          <div className="p-0 mt-3 d-flex justify-content-around">
            <UploadedMedia
              removeImage={removeImage}
              name="panLink"
              source={media?.panLink}
              sourceType={media?.panLinkType}
            />
            <UploadedMedia
              removeImage={removeImage}
              name="gstLink"
              source={media?.gstLink}
              sourceType={media?.gstLinkType}
            />
          </div>
          <Row className="p-0 mt-5">
            <FileInput
              handleImage={(e) => handleImage(e, 'panLink')}
              label="PAN *"
              name={'PAN'}
              placeholder="Upload PAN Card"
              handleClick={handleClick}
            />
            <FileInput
              handleImage={(e) => handleImage(e, 'gstLink')}
              label="GST *"
              name={'GST'}
              placeholder="Upload GST Certificate"
              handleClick={handleClick}
            />
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="p-0 mt-5 d-flex justify-content-around">
            <UploadedMedia
              removeImage={removeImage}
              name="cancelledChequeLink"
              source={media?.cancelledChequeLink}
              sourceType={media?.cancelledChequeLinkType}
            />
            <UploadedMedia
              removeImage={removeImage}
              name="productListLink"
              source={media?.productListLink}
              sourceType={media?.productListLinkType}
            />
          </div>
          <Row className="mt-3">
            <FileInput
              handleImage={(e) => handleImage(e, 'cancelledChequeLink')}
              label="Canceled Cheque *"
              name={'chq'}
              placeholder="Upload Cancelled Cheque"
              handleClick={handleClick}
            />
            <FileInput
              handleImage={(e) => handleImage(e, 'productListLink')}
              label="Product Listing (optional)"
              name={'pdc'}
              placeholder="Upload Product List"
              handleClick={handleClick}
            />
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="w-50 flex justify-content-center mx-auto">
            <Button disabled={loader} type="submit" className={styles.register_btn}>
              {loader ? 'Loading...' : 'Register'}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MediaSection;
